import type {BagAdvancedInsightsManager} from "../../../stores/managers/BagAdvancedInsightsManager";
import type React from "react";

type Types =
    'string'
    | 'number'
    | 'currency'
    | '2_decimal'
    | 'category'
    | 'selection'
    | 'string[]'
    | 'custom'
    | 'action';

export class HeaderSpecification<D = Record<string, any>> {
    onOrder?: () => void

    constructor(
        private readonly i: BagAdvancedInsightsManager,
        public label: string,
        public key: string,
        public type: Types,
        ordering_prefix: string,
        noOrdering?: boolean,
        public help?: React.ReactNode,
        public render?: (data: D) => React.ReactNode,
        public colorMapKey?: string,
    ) {
        if (!noOrdering) {
            this.onOrder = () => {
                if (this.i.getOrderingWithPrefix(ordering_prefix) === key)
                    this.i.setOrderingWithPrefix('-' + key, ordering_prefix);
                else
                    this.i.setOrderingWithPrefix(key, ordering_prefix);
                return;
            }
        }
    }
}

export type HeaderSpecificationType<D = Record<string, any>> = Omit<InstanceType<typeof HeaderSpecification<D>>, 'i'>
